import {
  REQUEST_MAKE_JUDGEMENT_ADD_DECISION,
  REQUEST_VALIDATE_EXPERT_REPORT,
  REQUEST_VALIDATE_JUDGEMENT_ON_MERITS,
  REQUEST_VALIDATE_JUDGEMENT_APPEAL,
  CREATE_CIVIL_PROCEEDING,
  REQUEST_ASSIGNED_EXPERT,
  REQUEST_VALIDATE_DISCLAIMER_WARRANTY,
  REQUEST_UPDATE_CIVIL,
  REQUEST_VALIDATE_CIVIL_PROCEEDING,
  REQUEST_MAKE_JUDGEMENT_ADD_DOCUMENT_DECISION,
  REQUEST_VALIDATE_ADD_VICTIMS_CARD,
  REQUEST_CREATE_VEHICLES,
  REQUEST_MAKE_DECISION_MISSION_EXPERTISE,
  REQUEST_MAKE_DECISION_MISSION_NOTICE_DEFICIENCY,
  REQUEST_GET_EXPERTS_USERS,
  SET_EXPERTS_USERS,
  REQUEST_ADD_APPRECIATION,
  REQUEST_UPDATE_CIVIL_PROCEEDING,
  REQUEST_SET_IS_SUSPICIOS_CLAIM,
  CREATE_JUDGEMENT_ADD,
  REQUEST_LOCK_CLAIM,
  REQUEST_UNLOCK_CLAIM,
  MAKE_DECISION_DOCUMENT_IMAGING,
  REQUEST_CHECK_CIVIL_PARTY_JUDICIARY_PROCESS,
  SET_CHECK_CIVIL_PARTY_JUDICIARY_PROCESS,
  SET_DECISION_JUDGEMENT_IDS,
  REQUEST_GET_CLAIM_HISTORY_ACTIONS,
  SET_CLAIM_HISTORY_ACTIONS,
  REQUEST_GET_CLAIM_HISTORY_SAGIS,
  SET_CLAIM_HISTORY_SAGIS,
  REQUEST_SET_STATUS_CLAIM_SAGIS,
  REQUEST_ADD_STAKE_HOLDER,
  REQUEST_UPDATE_PRIORITY_CLAIM_PROVISION,
  SET_INSTRUCTIONS,
  REQUEST_GET_INSTRUCTIONS,
  REQUEST_CREATE_INSTRUCTIONS,
  REQUEST_UPDATE_INSTRUCTIONS,
  REQUEST_RESET_HISTORY_STORE,
  REQUEST_CREATE_INCOME_CERTIFICATE,
  REQUEST_UPDATE_INCOME_CERTIFICATE,
  REQUEST_MAKE_DECISION_INCOME_CERTIFICATE,
  REQUEST_MAKE_DECISION_SUPPORT_DOCUMENT,
  REQUEST_GET_PENDING_TASKS_CLAIM,
  SET_PENDING_TASKS_CLAIM,
  REQUEST_GET_CLAIM_CIVIL_PARTY,
  SET_CLAIM_CIVIL_PARTY,
  REQUEST_ARCHIVE_JUDGEMENT,
  REQUEST_UPLOAD_DOCUMENT_MANAGER,
  REQUEST_GET_DECISION_FLOW_VICTIMS,
  SET_DECISION_FLOW_VICTIMS,
} from 'containers/CourtManagerLegalProceedings/constants';
import {
  IDecision,
  IExpertReport,
  IJudgementAppeal,
  IJudgementOnMerits,
} from 'containers/CourtManagerLegalProceedings/typings';

export const requestMakeJudgementAddDecision = (
  decision: IDecision,
  successCallback: Function,
) => ({
  type: REQUEST_MAKE_JUDGEMENT_ADD_DECISION,
  decision,
  successCallback,
});

export const requestValidateExpertReport = (
  expertReport: IExpertReport,
  successCallback: Function,
) => ({
  type: REQUEST_VALIDATE_EXPERT_REPORT,
  expertReport,
  successCallback,
});

export const requestValidateJudgementOnMerits = (
  judgementOnMerits: IJudgementOnMerits,
  successCallback: Function,
) => ({
  type: REQUEST_VALIDATE_JUDGEMENT_ON_MERITS,
  judgementOnMerits,
  successCallback,
});

export const requestValidateJudgementAppeal = (
  judgementAppeal: IJudgementAppeal,
  successCallback: Function,
) => ({
  type: REQUEST_VALIDATE_JUDGEMENT_APPEAL,
  judgementAppeal,
  successCallback,
});
export const requestCreateCivilProceeding = (
  civilProceeding: any,
  successCallback: Function,
) => ({
  type: CREATE_CIVIL_PROCEEDING,
  civilProceeding,
  successCallback,
});
export const requestUpdatedCivilProceeding = (
  newCivilProceeding: any,
  successCallback: Function,
) => ({
  type: REQUEST_UPDATE_CIVIL,
  newCivilProceeding,
  successCallback,
});
export const requestValidatedCivilProceeding = (
  newCivilProceeding: any,
  successCallback: Function,
) => ({
  type: REQUEST_VALIDATE_CIVIL_PROCEEDING,
  newCivilProceeding,
  successCallback,
});
export const requestAssignedExpert = (
  assignedExpert: any,
  successCallback: Function,
) => ({
  type: REQUEST_ASSIGNED_EXPERT,
  assignedExpert,
  successCallback,
});

export const requestValidateDisclaimerWarranty = (
  reason: any,
  successCallback: Function,
) => ({
  type: REQUEST_VALIDATE_DISCLAIMER_WARRANTY,
  reason,
  successCallback,
});

export const requestMakeJudgementAddDocumentDecision = (
  decision: IDecision,
  successCallback: Function,
) => {
  return {
    type: REQUEST_MAKE_JUDGEMENT_ADD_DOCUMENT_DECISION,
    decision,
    successCallback,
  };
};

export const requestAddVictims = (payload: any, successCallback: Function) => {
  return {
    type: REQUEST_VALIDATE_ADD_VICTIMS_CARD,
    payload,
    successCallback,
  };
};
export const requestAddVehicles = (payload: any, successCallback: Function) => {
  return {
    type: REQUEST_CREATE_VEHICLES,
    payload,
    successCallback,
  };
};
export const requestMakeDecisionMissionExpertise = (
  payload: any,
  successCallback: Function,
) => {
  return {
    type: REQUEST_MAKE_DECISION_MISSION_EXPERTISE,
    payload,
    successCallback,
  };
};

export const requestMakeDecisionMissionNoticeDeficiency = (
  payload: any,
  successCallback: Function,
) => {
  return {
    type: REQUEST_MAKE_DECISION_MISSION_NOTICE_DEFICIENCY,
    payload,
    successCallback,
  };
};
export const requestGetExpertUsers = (payload: any) => {
  return {
    type: REQUEST_GET_EXPERTS_USERS,
    payload,
  };
};

export const requestSetExpertUsers = (payload: any) => {
  return {
    type: SET_EXPERTS_USERS,
    payload,
  };
};

export const requestAddAppreciation = (
  payload: any,
  successCallback: Function,
) => {
  return {
    type: REQUEST_ADD_APPRECIATION,
    payload,
    successCallback,
  };
};

export const requestUpdateCivilProceeding = (
  payload: any,
  successCallback: Function,
) => {
  return {
    type: REQUEST_UPDATE_CIVIL_PROCEEDING,
    payload,
    successCallback,
  };
};
export const requestIsSuspiciosClaim = (
  payload: any,
  successCallback: Function,
) => {
  return {
    type: REQUEST_SET_IS_SUSPICIOS_CLAIM,
    payload,
    successCallback,
  };
};
export const requestCreateJudgementAdd = (
  payload: {},
  callback: Function,
  handleError: Function,
) => ({
  type: CREATE_JUDGEMENT_ADD,
  payload,
  callback,
  handleError,
});

export const requestLockClaim = (payload: { claimNumber: string }) => {
  return {
    type: REQUEST_LOCK_CLAIM,
    payload,
  };
};

export const requestUnlockClaim = (
  payload: { claimNumber: string },
  successCallBack?: Function,
) => {
  return {
    type: REQUEST_UNLOCK_CLAIM,
    payload,
    successCallBack,
  };
};

export const requestMakeDecisionsDocumentImaging = (
  payload: any,
  successCallBack: Function,
) => {
  return {
    type: MAKE_DECISION_DOCUMENT_IMAGING,
    payload,
    successCallBack,
  };
};

export const requestCheckCivilPartyJudiciaryProcess = (payload: any) => {
  return {
    type: REQUEST_CHECK_CIVIL_PARTY_JUDICIARY_PROCESS,
    payload,
  };
};

export const setCheckCivilPartyJudiciaryProcess = (payload: any) => {
  return {
    type: SET_CHECK_CIVIL_PARTY_JUDICIARY_PROCESS,
    payload,
  };
};

export const setDecisionsJudgementIds = (payload: any) => {
  return {
    type: SET_DECISION_JUDGEMENT_IDS,
    payload,
  };
};
export const requestGetClaimHistoryActions = (payload: any) => {
  return {
    type: REQUEST_GET_CLAIM_HISTORY_ACTIONS,
    payload,
  };
};

export const setClaimHistoryActions = (payload: any) => {
  return {
    type: SET_CLAIM_HISTORY_ACTIONS,
    payload,
  };
};
export const requestGetClaimHistorySagis = (payload: any) => {
  return {
    type: REQUEST_GET_CLAIM_HISTORY_SAGIS,
    payload,
  };
};

export const setClaimHistorySagis = (payload: any) => {
  return {
    type: SET_CLAIM_HISTORY_SAGIS,
    payload,
  };
};

export const requestSetStatusClaimSagis = (
  payload: any,
  successCallBack: Function,
) => {
  return {
    type: REQUEST_SET_STATUS_CLAIM_SAGIS,
    payload,
    successCallBack,
  };
};

export const requestCreateStakeHolder = (
  payload: any,
  successCallBack: Function,
) => {
  return {
    type: REQUEST_ADD_STAKE_HOLDER,
    payload,
    successCallBack,
  };
};

export const requestSetPriorityClaimProvision = (payload: any) => {
  return {
    type: REQUEST_UPDATE_PRIORITY_CLAIM_PROVISION,
    payload,
  };
};
export const requestGetInstructions = (payload: any) => {
  return {
    type: REQUEST_GET_INSTRUCTIONS,
    payload,
  };
};
export const setInstructions = (payload: any) => {
  return {
    type: SET_INSTRUCTIONS,
    payload,
  };
};
export const requestCreateInstruction = (
  payload: any,
  successCallBack: Function,
) => {
  return {
    type: REQUEST_CREATE_INSTRUCTIONS,
    payload,
    successCallBack,
  };
};
export const requestUpdateInstruction = (
  payload: any,
  successCallBack: Function,
) => {
  return {
    type: REQUEST_UPDATE_INSTRUCTIONS,
    payload,
    successCallBack,
  };
};

export const requestResetHistoryStore = () => {
  return {
    type: REQUEST_RESET_HISTORY_STORE,
  };
};
export const requestCreateIncomeCertificate = (
  payload: any,
  successCallBack: Function,
) => {
  return {
    type: REQUEST_CREATE_INCOME_CERTIFICATE,
    payload,
    successCallBack,
  };
};
export const requestUpdateIncomeCertificate = (
  payload: any,
  successCallBack: Function,
) => {
  return {
    type: REQUEST_UPDATE_INCOME_CERTIFICATE,
    payload,
    successCallBack,
  };
};

export const requestMakeDecisionIncomeCertificate = (
  payload: any,
  successCallBack: Function,
) => {
  return {
    type: REQUEST_MAKE_DECISION_INCOME_CERTIFICATE,
    payload,
    successCallBack,
  };
};

export const requestMakeDecisionSupportDocument = (
  payload: any,
  successCallBack: Function,
) => {
  return {
    type: REQUEST_MAKE_DECISION_SUPPORT_DOCUMENT,
    payload,
    successCallBack,
  };
};
export const requestGetPendingTasksClaim = (payload: any) => {
  return {
    type: REQUEST_GET_PENDING_TASKS_CLAIM,
    payload,
  };
};

export const setPendingTasksClaim = (payload: any) => {
  return {
    type: SET_PENDING_TASKS_CLAIM,
    payload,
  };
};
export const requestGetClaimCivilParty = (payload: any) => {
  return {
    type: REQUEST_GET_CLAIM_CIVIL_PARTY,
    payload,
  };
};
export const setClaimCivilParty = (payload: any) => {
  return {
    type: SET_CLAIM_CIVIL_PARTY,
    payload,
  };
};
export const requestArchiveJudgement = (
  payload: any,
  successCallBack: Function,
) => {
  return {
    type: REQUEST_ARCHIVE_JUDGEMENT,
    payload,
    successCallBack,
  };
};
export const requestUploadDocumentManager = (
  payload: any,
  successCallBack: Function,
) => {
  return {
    type: REQUEST_UPLOAD_DOCUMENT_MANAGER,
    payload,
    successCallBack,
  };
};

export const requestGetDecisionFlowVictims = (claimId: number) => {
  return {
    type: REQUEST_GET_DECISION_FLOW_VICTIMS,
    claimId,
  };
};

export const setDecisionFlowVictims = (payload: any) => {
  return {
    type: SET_DECISION_FLOW_VICTIMS,
    payload,
  };
};
